import { render } from "./DataCalendar.vue?vue&type=template&id=28d18638&scoped=true"
import script from "./DataCalendar.vue?vue&type=script&lang=js"
export * from "./DataCalendar.vue?vue&type=script&lang=js"

import "./DataCalendar.vue?vue&type=style&index=0&id=28d18638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d18638"]])

export default __exports__